module.exports = __webpack_public_path__ + "static/img/videoPoster.e54039d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/videos/videoPoster.jpg
// module id = 76Yw
// module chunks = 1